---
ID: 66d77f144a9fb5d976f7d518
---

<script>
    import Loader from "$lib/components/elements/Loader.svelte"

    const blocks = [
  {
    "id": "15P9uXfnqd",
    "type": "text",
    "html": "<p>Links are essential for website navigation, connecting users to both internal pages and external resources. EasyPageGO simplifies the process of adding and managing links within your content, ensuring a smooth browsing experience.</p><h2 id=\"external-links\"><b>External Links</b></h2><p>When you create an external link in EasyPageGO, it automatically includes the following attributes:</p><ul><li><code><b>rel=\"noopener noreferrer\"</b></code>: Enhances security and privacy by preventing the linked page from accessing details about your site, such as referral information. This attribute also mitigates potential security risks.</li><li><code><b>target=\"_blank\"</b></code>: Opens the external link in a new tab, allowing visitors to explore additional resources while keeping your site open in their original tab.</li></ul><p>These features help maintain user engagement and safeguard your site’s integrity.</p><h2 id=\"internal-links\"><b>Internal Links</b></h2><p>Internal links in EasyPageGO offer flexibility and reliability. When you create an internal link, in the editor it directly references the page itself rather than a static URL. This ensures that if you rename or move a page, the link will automatically adjust to the new location, preventing broken links.</p>"
  },
  {
    "id": "yztw2AB5ZC",
    "type": "callout",
    "variant": "success",
    "html": "<p>If a linked page is deleted, the internal link will automatically be removed. The site will build successfully.</p>"
  },
  {
    "id": "8Z-5eBkovG",
    "type": "text",
    "html": "<p>Rest assured that in the final built output, internal links will automatically point to the correct paths rather than the internal references used during editing. This ensures that all links function properly in the live version of your site.</p>"
  }
];
</script>

{#each blocks as block}
<Loader {block}/>
{/each}